// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mx-input-wrapper:has(> .border-danger) .mx-icon-calendar {\n  color: var(--danger);\n}\n.mx-input {\n  -webkit-box-shadow: none;\n}\n[dir] .mx-input {\n          box-shadow: none;\n}\n", ""]);
// Exports
module.exports = exports;
